import { atom } from 'jotai';
import { atomWithImmer } from 'jotai-immer';
import { RankingRuleActionType } from 'types/ranking';

export const rankingRuleTriggerModalAtom = atomWithImmer<{
  visible: boolean;
  type: string;
  cascadingConcepts: RankingRuleTriggerConcept[][];
  exactConcepts: RankingRuleTriggerConcept[][];
  exactKeywords: string[];
  phraseKeywords: string[];
  partialKeywords: string[];
}>({
  visible: false,
  type: '',
  cascadingConcepts: [],
  exactConcepts: [],
  exactKeywords: [],
  phraseKeywords: [],
  partialKeywords: [],
});

export const rankingRuleTargetBoosts = atom<RankingRuleTargetBoostItem[]>([]);

export const rankingRuleTargetBuries = atom<RankingRuleTargetBuryItem[]>([]);

export const rankingRuleTargetModalAtom = atomWithImmer<{
  visible: boolean;
  type: string;
  actionType: RankingRuleActionType;
  boosts: RankingRuleTargetBoostItem[];
  buries: RankingRuleTargetBuryItem[];
}>({
  type: '',
  actionType: RankingRuleActionType.Boost,
  visible: false,
  boosts: [],
  buries: [],
});

export const rankingRuleEditResult = atomWithImmer({
  resultMsg: '',
  hasError: false,
});
